<template>
    <ModalComponent
        name="crear-categoria"
        title="Crear categoría"
        v-on:close="() => close()"
    >
        <FormComponent
            :categoria="categoria"
            :loading="loading"
            @terminado="crearCategoria"
        />
    </ModalComponent>
</template>

<script>
    import ModalComponent from "@/components/backend/components/ModalComponent";
    import FormComponent from '@/components/backend/productos/categorias/FormComponent';

    export default {
        data() {
            return {
                loading: false,
                categoria: {
                    filters: {}
                }
            }
        },
        methods: {
            crearCategoria() {
                this.loading = true;

                this.$store.dispatch(this.config.getVuexAlias('back.teatro.categorias.crear'), this.categoria).then(res => {
                    this.$toast.success(res.data.message);
                    this.$router.push({ name: 'back.productos.categorias' });
                }).catch(error => {
                    this.$toast.error(error.response?.data?.message);
                }).finally(() => {
                    this.loading = false;
                    this.close(true);
                    this.categoria = {
                        filters: {},
                        name: '',
                        description: ''
                    };
                });
            },
            close(reload) {                
                this.$emit('close', 'crear-categoria', reload);
            }
        },
        components: {
            ModalComponent, FormComponent
        }
    }
</script>
<!--  -->